<app-header></app-header>

<!--========= Hero Area ===========-->
<app-hero></app-hero>

<!--======== About Section ========-->
<app-about></app-about>

<!--======== Our Features Section ========-->
<app-our-features></app-our-features>

<!--======== Why Choose Section ========-->
<app-why-choose-us></app-why-choose-us>

<!--======== Our Services Section ========-->
<app-our-services></app-our-services>

<!--======== Our Process Section ========-->
<app-our-process></app-our-process>

<!--======== Recent Projects Section ========-->
<app-recent-project></app-recent-project>

<!--======== Blog Section ========-->
<app-blog-area></app-blog-area>

<!--======== Customer Service Strip Section ========-->
<app-customer-service-strip></app-customer-service-strip>

<!--======== Testimonial Section ========-->
<app-testimonial></app-testimonial>

<!--======== Count Area Section ========-->
<app-counter></app-counter>

<!--======== Brand Section ========-->
<app-brand-slider></app-brand-slider>

<!--======== Footer Section ========-->
<app-footer></app-footer>